import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';
import { Option } from 'fp-ts/Option';
import { atom, selector, useRecoilCallback } from 'recoil';

import { CardHtml } from '../domain/CardHtml';
import { NextStep } from '../domain/NextStep';

export const nextStepState = atom<Option<NextStep>>({
  key: 'nextStepState',
  default: O.none,
});

export const nextStepCounterState = atom<number>({
  key: 'nextStepCounter',
  default: 0,
});

export const useUpdateStepState = () =>
  useRecoilCallback(
    ({ set }) =>
      (newData: Option<NextStep>) => {
        set(nextStepState, newData);
        set(nextStepCounterState, (old) => old + 1);
      },
    []
  );

export const nextCardState = selector<Option<CardHtml>>({
  key: 'nextCardState',
  get: ({ get }) =>
    pipe(
      get(nextStepState),
      O.chain((nextStep: NextStep) => nextStep.c)
    ),
});
